module.exports = __webpack_public_path__ + "static/aop (1)-f397b18a5432dcffeec9b63e4e8916e8.jpg";